export const Copy = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.8 5.8V3.56C5.8 2.66392 5.8 2.21587 5.97439 1.87362C6.12779 1.57256 6.37256 1.32779 6.67362 1.17439C7.01587 1 7.46392 1 8.36 1H14.44C15.3361 1 15.7841 1 16.1264 1.17439C16.4274 1.32779 16.6722 1.57256 16.8256 1.87362C17 2.21587 17 2.66392 17 3.56V9.64C17 10.5361 17 10.9841 16.8256 11.3264C16.6722 11.6274 16.4274 11.8722 16.1264 12.0256C15.7841 12.2 15.3361 12.2 14.44 12.2H12.2M3.56 17H9.64C10.5361 17 10.9841 17 11.3264 16.8256C11.6274 16.6722 11.8722 16.4274 12.0256 16.1264C12.2 15.7841 12.2 15.3361 12.2 14.44V8.36C12.2 7.46392 12.2 7.01587 12.0256 6.67362C11.8722 6.37256 11.6274 6.12779 11.3264 5.97439C10.9841 5.8 10.5361 5.8 9.64 5.8H3.56C2.66392 5.8 2.21587 5.8 1.87362 5.97439C1.57256 6.12779 1.32779 6.37256 1.17439 6.67362C1 7.01587 1 7.46392 1 8.36V14.44C1 15.3361 1 15.7841 1.17439 16.1264C1.32779 16.4274 1.57256 16.6722 1.87362 16.8256C2.21587 17 2.66392 17 3.56 17Z"
        stroke="#737D86"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
